
import * as React from 'react';
import { createContext, useEffect, useReducer, useRef, useState } from 'react';
import SearchTour from './info/school_tour';
import { useLocation } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { ISearchAppState } from '..';

//import { SearchBar } from '../../../search/app/components/searching/search-bar';
import { FetchPendingAction } from '../../../search/app/middleware/fetch-middleware';
import { IContentProps } from '../../../search/app/models/content-props';
import { getAllCpsSchools, getPageProperties, search } from '../services/cps-school-api';
import { addressGeocode, getMapName, nearMeSearch, radiusSearch, getAllBoundaries, getBoundaries, getTier } from '../services/maps-api';
import { getAllPrekSchools } from '../services/prek-school-api';
import { getSummerPrograms } from '../services/summer-prog-api';
import { addFilterCounts, lcFirst, formatedSchools } from '../utility/api-utilities';
import FilterForm from './inputs/filter-form';
import SearchBar from './inputs/search-bar';
import SearchPageSelector from './navigation/search-page-selector';
import ProfilePage from './pages/profile-page';
import SchoolSearchHelp from './info/search-school-help';

import ResultList from './results/search-results';

import CompareSchools from './pages/compare-schools';
//import BackgroundMap from './info/background-map';
import SchoolMap from './results/school-map';
import { communityOverlay, zipOverlay, networkOverlay } from './results/map-container-config';
import { processorDefaultState, processorReducer, PROCESSOR_RESET_ACTION, PROCESSOR_SET_GOCPS, PROCESSOR_TIER_PROCESS } from '../services/search-processor';
import { mapControllerDefaultState, mapControllerReducer, MAP_CLEAR_PIN, MAP_FOCUS_POLYGON, MAP_RESET, MAP_SET_PIN_LOCATION, MAP_FOCUS_NETWORK_NO_POLYGONE } from '../services/map-controller';
import { FilterAction, filterDefaultState, filterReducer } from '../services/filter-controller';
import { CelRequest, Mode, PAGE_MODE, SchoolType, SCHOOL_TYPE } from "../interfaces"

export const AppContext = createContext(undefined)


// @TODO naming is a nightmare right now, once prek is confirmed go through and fix all of this nonsense and name things well

function SchoolSearchComponent(props) {
    // set the mode with a global variable "pageMode" in the head script of the search page. If undefined, use "prek"
    const pageMode = (window as any).pageMode ? (window as any).pageMode : 'prek';

    const [mode, setMode] = useState<Mode>(pageMode);
    const [schoolResults, setSchoolResults] = useState([]);
    //const [programResults, setProgramResults] = useState([]);
    //const [filterSet, setFilterSet] = useState([]); // maybe roll these and facets back together
    const [selectedSchoolId, setRealSelectedSchoolId] = useState(null);
    const [showHelpWindow, setShowHelpWindow] = useState(null);
    const [mapSelectedSchoolId, setMapSelectedSchoolId] = useState(null);
    const [resultsInfoString, setResultsInfoString] = useState('');
    const [viewMode, setViewMode] = useState('cards');
    const [showCompare, setShowCompare] = useState(false);
    const [showMoreInfoCompare, setShowMoreInfoCompare] = useState(false);
    const [compareSchools, setCompareSchools] = useState([]);
    const [resetCount, setResetCount] = useState(0);
    const [searchTermOverride, setSearchTermOverride] = useState('');
    const [focusedSchool, setFocusedSchool] = useState(null); // this was lifted out of search results. @TODO clean this and mapSelectedID up when it won't cause so many conflicts
    const [maximized, setMaximized] = useState(false);
    const [backgroundSchool, setBackgroundSchool] = useState(false);
    const [selectedOverlay, setSelectedOverlay] = useState(null);
    const [resultAlert, setResultAlert] = useState(null);
    const [run, setRun] = useState(false);
    const [tourStep, setTourStep] = useState(0);
    const [sidebarFilters, setSidebarFilters] = useState();
    const [helpContent, setHelpContent] = useState(null);
    const [schoolListError, setSchoolListError] = useState('');
    const [showLoading, setShowLoading] = useState(false);
    const [isShowFilterWindow, setIsShowFilterWindow] = useState(false);
    const [searchProcessor, searchProcessorDispatch] = useReducer(processorReducer, processorDefaultState);
    const [mapController, mapControllerDispatch] = useReducer(mapControllerReducer, mapControllerDefaultState);
    const [filterController, filterControllerDispatch] = useReducer(filterReducer, filterDefaultState);
    const [networkSelectedSchools, setNetworkSelectedSchools] = useState(null);
    const [tier, setTier] = useState(null);
    const [isMapLoaded, setIsMapLoaded] = useState(false);
    const [isLongPress, setLongPress] = useState(false);
    const [centeredMap, setCenteredMap] = useState(false);
    const [profileRedirectUrl, setProfileRedirectUrl] = useState(null);

    // @TODO on next cleanup,these should be rolled into context better
    React.useEffect(() => {
        getPageProperties().then((properties) => {
            if (properties.openExpanded) {
                toggleMaximize();
            }
            if (properties.openExpanded) {
                setViewMode('list');
            }
            setProfileRedirectUrl(properties.schoolProfilePageUrl);
        })
    }, [])

    const setSelectedSchoolId = (id) => {
        setRealSelectedSchoolId(id);
        history.replaceState('school', 'School Page', window.location.pathname);
        if (id) {
            history.replaceState('school', 'School Page', `?id=${id}`);
        }
    }

    const onCloseSchoolInfoModal = (id) => {
        setRealSelectedSchoolId(null);
        if (id) {
            if (taggedSchools?.length === 1) {
                history.replaceState('school', 'School Page', `?schoolSearchId=${id}`)
            } else {
                history.replaceState('school', 'School Page', window.location.pathname);
            }
        }
    }

    useEffect(() => {
        const query = new URLSearchParams(window.location.search);        
        // @ts-ignore
        if (query.get('id')) {
            getPageProperties().then((props) => {
                if (props.schoolProfilePageUrl && mode == PAGE_MODE.GOCPS) {
                    // @ts-ignore
                    window.location = '' + props.schoolProfilePageUrl + query.get('id');
                } else {
                    // @ts-ignore
                    setSelectedSchoolId(query.get('id'))
                }
            })
        }
    }, []);

    useEffect(() => {
        if (mode == PAGE_MODE.GOCPS) {
            searchProcessorDispatch({
                action: PROCESSOR_SET_GOCPS
            });
        }
    }, []);

    useEffect(() => {
        getPageProperties().then((data) => {
            setHelpContent(data.helpContent)
        });
        
        setShowLoading(true);
        const getSchoolFn = [];
        switch (mode) {
            case PAGE_MODE.GOCPS: getSchoolFn.push(getAllCpsSchools()); break;
            case PAGE_MODE.SUMMER_PROGRAMM: getSchoolFn.push(getSummerPrograms()); break;
            default: getSchoolFn.push(getAllPrekSchools()); break;
        }
        Promise.all(getSchoolFn).then((res: CelRequest[]) => {
            filterControllerDispatch({
                action: FilterAction.LOAD_FROM_FACET_ENDPOINT,
                facets: res[0].facets.map(f => ({ searchFields: [f.fieldName], ...f, }))
            })

            setSchoolResults(
                formatedSchools(res[0].results)
                    .sort((a, b) => a._epi.title.localeCompare(b._epi.title))
            );
            setShowLoading(false);
            mapControllerDispatch({ action: MAP_RESET });
        }).catch(err => {
            setShowLoading(false);
            setSchoolListError('Something went wrong, please try refreshing the page.');
        })
        
    }, [mode]);

    useEffect(() => {
        if (run) {
            const parentEl = document.getElementsByClassName('results-list');
            parentEl[0].scrollTop = 0;
        }
    }, [run]);

    const addressAlert = (address, tier) => {
        return <div className="neighborhood-alert">
            <div className="tier">
                <img src="/Static-Adage/img/search/yellow-pin-lg.png" alt="pin icon" />
                <p>Tier {tier}</p>
            </div>
            <div className="text">
                <p>
                    Based on your address, <strong>{address}</strong>, you can attend one of the neighborhood
                    schools <span className="neighborhood-icon" role="img" aria-label="Neighborhood school icon"></span> indicated
                    below. All data visualizations on maps should be considered approximate.
                    Neighborhood attendance boundaries can only be confirmed officially through the
                    Office of Planning and Data Management by calling 773.553.3270 or emailing
                    demographics@cps.edu.
                </p>
            </div>
            <div className="close">
                <button onClick={() => { setResultAlert(null) }}>×</button>
            </div>
        </div>
    }

    const searchSchools = (term) => {
        resetOverlay();
        if (term) {
            setIsShowFilterWindow(false);
        }
        // @TODO clean this up
        filterControllerDispatch({ action: FilterAction.RESET })
        //setSearchTerm(term)
        mapControllerDispatch({ action: MAP_CLEAR_PIN });
        setResultsInfoString('')
        setSearchTermOverride('')
        setSelectedSchoolId(null);
        setResetCount(resetCount + 1);


        if (!term) {
            return;
        }
        // check if it could be an address
        addressGeocode(term).then(res => {
            // this is an address search
            if (res) {
                mapControllerDispatch({
                    action: MAP_SET_PIN_LOCATION,
                    point: res.location
                });
                setSearchTermOverride(res.address);

                if (mode == PAGE_MODE.GOCPS) {
                    Promise.all([getTier(res.location.lat, res.location.lng)]).
                        then(tierResult => {
                            const [tier] = tierResult;
                            setTier(tier);
                            if (tier == -1) { // address search was outside of Chicago - show no results
                                setResultAlert(null)
                            }
                            else if (tier) {
                                setResultAlert(addressAlert(res.address, tier));
                            }
                        });
                }
            } else {
                filterControllerDispatch({ action: FilterAction.RESET })
            }
        });
        return;
    }

    // this has a bad big O. unroll it later
    // build all the filters that apply
    const appliedFilters = [];
    for (let filter of filterController.filters) {
        // make sure a term is selected
        const terms = filter.terms.filter(term => term.enabled === true);
        if (terms.length > 0) {
            appliedFilters.push({
                field: filter.fieldName,
                terms: terms.map(t => t.term),
                searchFields: filter.searchFields
            });
        }
    }

    const schools = schoolResults.filter(school => {
        for (let filter of appliedFilters) {
            if (filter.field == 'id') {
                if (!filter.terms.some(term => {
                    // check if any of the fields for this rolled up group have the term
                    for (let field of filter.searchFields) {
                        if (school._epi.facets[lcFirst(field)]?.includes(term)) {
                            return true;
                        }
                    }
                })) {
                    return false;
                }
            } else {
                if (!filter.terms.every(term => {
                    // check if any of the fields for this rolled up group have the term
                    for (let field of filter.searchFields) {
                        if (school._epi.facets[lcFirst(field)]?.includes(term)) {
                            return true;
                        }
                    }
                })) {
                    return false;
                }
            }
        }
        return true;
    });

    useEffect(() => {
        if (!mapController.pin) {
            return;
        }

        console.log('mapController: ', mapController);
        // if CPS, do a boundary. otherwise a radius
        if (mode == PAGE_MODE.GOCPS) {
            latLongSearch(mapController.pin.lat, mapController.pin.lng);
        } else {
            radius(mapController.proximity, mapController.pin);
        }

    }, [mapController.pin, mapController.proximity])

    //addFilterCounts(filterSet, schools); @todo mike figure this out
    const radius = (proximity, point) => {
        if (point) {
            radiusSearch(point.lat, point.lng, proximity, mode).then(ids => {
                filterControllerDispatch({ action: FilterAction.SET_ID_FILTER, ids: ids });
            });
        } else {
            nearMeSearch(proximity, mode).then(searchRes => {
                mapControllerDispatch({
                    action: MAP_SET_PIN_LOCATION,
                    point: searchRes.pos
                });
                setSearchTermOverride(searchRes.address ?? '');
                //setIdFilter(searchRes.ids)
                getTier(searchRes.pos.lat, searchRes.pos.lng).then(tierRes => {
                    if (mode === PAGE_MODE.GOCPS) {
                        setResultAlert(addressAlert(searchRes.address, tierRes));
                    }
                });
                filterControllerDispatch({ action: FilterAction.SET_ID_FILTER, ids: searchRes.ids });
            });
        }

    }

    const nearMe = () => {
        if (mapSelectedSchoolId) {
            history.replaceState('school', 'School Page', window.location.pathname);
            filterControllerDispatch({ action: FilterAction.RESET });
            mapControllerDispatch({ action: MAP_RESET });
            setMapSelectedSchoolId(null);
        }
        radius(mapController.proximity, null)
    }

    const setIdsFromSearch = (ids) => {
        filterControllerDispatch({ action: FilterAction.SET_ID_FILTER, ids: ids })
    }

    const openCompareSchools = (schools) => {
        setCompareSchools(schools);
        setShowCompare(true);
    }

    const closeCompare = () => {
        setShowCompare(false);
        setShowMoreInfoCompare(false);
        //setCompareSchools([])
    }

    const leaveCompare = (id) => {
        setShowCompare(false);
        setShowMoreInfoCompare(true);
        setSelectedSchoolId(id);
    }

    const resetSearch = () => {
        //    filterControllerDispatch({ action: FilterAction.RESET });
        //    mapControllerDispatch({ action: MAP_CLEAR_PIN });
        //    setMapSelectedSchoolId(null);
        //    setResultsInfoString('');
        //    setSearchTermOverride('');
        //    setResetCount(resetCount + 1);
        //    setSelectedOverlay(null);
        //    searchProcessorDispatch({ action: PROCESSOR_RESET_ACTION });
        //    setResultAlert(null);
        //    mapControllerDispatch({ action: MAP_RESET });
        //    setFocusedSchool(null);
        //    setCompareSchools([]);
        history.replaceState('school', 'School Page', window.location.pathname);
        window.location.reload();
    }

    const showPage = !showCompare && !selectedSchoolId && !showHelpWindow;

    const toggleMaximize = () => {
        document.getElementsByTagName('html')[0].classList.remove('big-mode');
        if (!maximized)
            document.getElementsByTagName('html')[0].classList.add('big-mode');
        setMaximized(!maximized);
    }
    // @ts-ignore
    window.maximize = toggleMaximize;

    const toggleViewMode = () => {
        setViewMode(viewMode == 'cards' ? 'list' : 'cards');
    }

    const selectOverlay = (overlay) => {
        if (overlay.noApi) {
            // just set the config data and let the map handle it
            setSelectedOverlay({
                config: overlay
            });
        } else {
            getMapName(overlay.name, overlay.year, mode).then((data) => {
                setSelectedOverlay({
                    ...data,
                    config: overlay
                });
            });
        }
    }

    const addNetworkOverlay = (term) => {
        Promise.all([getMapName('NETWORK_ES', 2022, mode), getMapName('NETWORK_HS', 2022, mode)])
            .then(result => {
                const newNetworks = {
                    type: "FeatureCollection",
                    features: []
                }
                if (result.length > 0) {
                    result.forEach(network => newNetworks.features.push(...network.features))
                }
                return newNetworks;
            })
            .then((networks) => {
                if (networks.features.some(i => i.properties.Network.toLowerCase() == term.toLowerCase())) {

                    setSelectedOverlay({
                        features: networks.features.filter(feat => feat.properties.Network.toLowerCase() == term.toLowerCase()),
                        config: networkOverlay,
                        type: networks.type
                    });
                    mapControllerDispatch({
                        action: MAP_FOCUS_POLYGON,
                        polygon: networks.features.filter(feat => feat.properties.Network.toLowerCase() == term.toLowerCase())[0],
                        overlay: networkOverlay
                    })
                } else {
                    setSelectedOverlay(null);
                    mapControllerDispatch({
                        action: MAP_FOCUS_NETWORK_NO_POLYGONE,
                    })
                }
            })
    }

    const addZipOverlay = (zip) => {
        // clear out stuff. overlay stuff should probably be moved into a reducer.
        const overlay = zipOverlay;
        getMapName(overlay.name, overlay.year, mode).then((data) => {
            const zipArray = data.features.filter(feat => feat.properties.ZIP == zip);
            if (zipArray.length > 0) {
                mapControllerDispatch({
                    action: MAP_FOCUS_POLYGON,
                    polygon: zipArray[0]
                })
            }
            setSelectedOverlay({
                ...data,
                features: zipArray,
                config: overlay
            });
        });
    }

    const centeredMapWithoutOverlays = () => {
        const schools = taggedSchools;
    }
    const addCommunityOverlay = (community) => {
        // clear out stuff. overlay stuff should probably be moved into a reducer.
        setSelectedSchoolId(null);
        setMapSelectedSchoolId(null);

        const overlay = communityOverlay;
        getMapName(overlay.name, overlay.year, mode).then((data) => {
            mapControllerDispatch({
                action: MAP_FOCUS_POLYGON,
                polygon: data.features.filter(feat => feat.properties.COMMUNITY.toLowerCase() == community.toLowerCase())[0]
            })
            setSelectedOverlay({
                ...data,
                features: data.features.filter(feat => feat.properties.COMMUNITY.toLowerCase() == community.toLowerCase()),
                config: overlay
            });
        });
    }

    const addSchoolOverlay = (schoolId) => {
        if (mode != PAGE_MODE.GOCPS) return;
        getAllBoundaries().then((data) => {
            setSelectedOverlay({
                ...data,
                features: data.features.filter(feat => feat.properties.SCHOOL_ID == '' + schoolId),
                config: {}
            });
        });
    }

    const latLongSearch = (lat, lng) => {
        const radiusPromise = radiusSearch(lat, lng, mapController.proximity, mode);
        const boundariesPromise = getBoundaries(lat, lng).then(res => res.features.map(f => f.properties.SCHOOL_ID));
        Promise.all([radiusPromise, boundariesPromise]).then(res => {
            //setMapZones(res);
            const [radiusIds, boundaryIds] = res;
            const schoolIds = [...boundaryIds, ...radiusIds];
            searchProcessorDispatch({
                action: PROCESSOR_TIER_PROCESS,
                tierIds: boundaryIds
            })
            filterControllerDispatch({ action: FilterAction.SET_ID_FILTER, ids: schoolIds });
            if (!isLongPress) {
                resetOverlay();
            }
        })
    }

    const resetOverlay = () => {
        if (isLongPress) {
            setLongPress(false);
        }
        setSelectedOverlay(null)
    }

    const onDeleteCompare = (id) => {
        setCompareSchools(compareSchools.filter(s => s._epi.id !== id));
    }

    const taggedSchools = searchProcessor.mutator([...schools]);

    const siteBody = document.querySelector('body');

    const pageOverlay = document.querySelector<HTMLElement>('.school-modal-overlay');

    //target the first .page after the header to add a class for full width
    //need to do this since we are targeting a parent epi element above and outside of the school search app
    const pageBody = document.querySelector<HTMLElement>('header + .page');

    if (pageBody) {
        pageBody.classList.add('full-width-page');
    }

    if (showPage) {
        siteBody.style.overflow = "auto";
        if (pageOverlay) {
            pageOverlay.style.display = "none";
        }
    } else {
        siteBody.style.overflow = "hidden";
        pageOverlay.style.top = `${window.scrollY.toString()}px`;
        pageOverlay.style.display = "block";
    }

    // We probably want a broker page instead of more logic in here

    return (
        <AppContext.Provider value={{
            maximized: maximized,
            school: backgroundSchool,
            resultSchools: taggedSchools,
            //resultPrograms: taggedPrograms,
            mode: mode,
            viewMode: viewMode,

            latLongSearch: latLongSearch,
            searchProcessor: searchProcessor,

            mapController: mapController,
            mapControllerDispatch: mapControllerDispatch,

            filterController: filterController,
            filterControllerDispatch: filterControllerDispatch,

            resultAlert: resultAlert,
            setResultAlert: setResultAlert,

            mapSelectedSchoolId: mapSelectedSchoolId,
            setMapSelectedSchoolId: setMapSelectedSchoolId,

            focusedSchool: focusedSchool,
            setFocusedSchool: setFocusedSchool, // @todo clean this up when it won't conflict with all of the other map stuff

            setBackgroundSchool: setBackgroundSchool,
            resetSearch: resetSearch,
            toggleMaximize: toggleMaximize,
            toggleViewMode: toggleViewMode,

            selectedOverlay: selectedOverlay,
            selectOverlay: selectOverlay,
            addZipOverlay: addZipOverlay,
            addCommunityOverlay: addCommunityOverlay,
            addSchoolOverlay: addSchoolOverlay,
            resetOverlay: resetOverlay,

            isShowFilterWindow: isShowFilterWindow,
            setIsShowFilterWindow: setIsShowFilterWindow,
            tourOpen: run,

            addNetworkOverlay: addNetworkOverlay,
            centeredMapWithoutOverlays: centeredMapWithoutOverlays,
            setNetworkSelectedSchools: setNetworkSelectedSchools,
            networkSelectedSchools: networkSelectedSchools,

            tier: tier,
            setSearchTermOverride: searchSchools,
            isMapLoaded: isMapLoaded,
            setIsMapLoaded: setIsMapLoaded,
            isLongPress: setLongPress,
            openSchoolProfile: setSelectedSchoolId, // cleaner name when used in other components
            profileRedirectUrl: profileRedirectUrl,

            centeredMap: centeredMap,
            setCenteredMap: setCenteredMap
        }}>
            {mode == SCHOOL_TYPE.SUMMER_PROGRAMM && <h2 className="school-search-map-title">CPS Summer School Programs</h2>}
            <div className={`school-search container ${mode}`}>
                <div className="map-container">
                    <SchoolMap focus={focusedSchool} overlays={null} schools={taggedSchools} checkedSchools={compareSchools} height={maximized ? "100vh" : "800px"} selectedSchoolId={setSelectedSchoolId} />
                </div>
           

                <div className={`overlay-area`}>
                    <div className="page">
                        <div className={`overlay ${mode}`}>
                            <SearchBar setIds={setIdsFromSearch} nearMeSearch={nearMe} searchSchools={searchSchools} setViewMode={setViewMode} resetCount={resetCount} termOverride={searchTermOverride} showHelp={setShowHelpWindow} />
                            <ResultList
                                showLoading={showLoading}
                                openCompareSchools={openCompareSchools}
                                viewMode={viewMode}
                                max={10}
                                selectSchool={(s) => setSelectedSchoolId(s)}
                                radiusSearch={radius}
                                resultsInfoString={resultsInfoString}
                                compareSchoolsList={compareSchools}
                                onDeleteCompareSchoolsList={(schools) => setCompareSchools([...schools])}
                                schoolListError={schoolListError}
                                tier={tier}
                            />
                        </div>
                    </div>
                </div>
                <SearchTour run={run} setRun={setRun} mode={mode} resultsMode={viewMode} />
            </div>
            <div className="school-modal-overlay">
                <div className="page">
                    {selectedSchoolId && <ProfilePage close={() => { onCloseSchoolInfoModal(selectedSchoolId); setBackgroundSchool(null); showMoreInfoCompare && setShowCompare(true) }} schoolId={selectedSchoolId} schoolResults={schoolResults }/>}
                    {showCompare && <CompareSchools schools={compareSchools} show={showCompare} close={closeCompare} selectSchool={leaveCompare} onDeleteSchool={onDeleteCompare} />}
                    {showHelpWindow && <SchoolSearchHelp close={() => setShowHelpWindow(null)} helpContent={helpContent} tourOpen={() => { setShowHelpWindow(null); setRun(true) }} />}
                </div>
            </div>
        </AppContext.Provider>
    )
}

export default SchoolSearchComponent;